export enum Environment {
    Sandbox = 'sandbox',
    Live = 'live',
}
